import { GET } from "../API";

export const getVideoBreakdownAPICall = (
  projectId,
  page,
  itemsPerPage,
  onSuccess,
  onError,
  dateFilters = {}
) => {
  const params = new URLSearchParams();

  if (page) params.append('page', page);
  if (itemsPerPage) params.append('per_page', itemsPerPage);
  if (dateFilters.start_date) params.append('start_date', dateFilters.start_date);
  if (dateFilters.end_date) params.append('end_date', dateFilters.end_date);

  const url = process.env.REACT_APP_API_PATH + `/public_api/projects/${projectId}/video_translations${params.toString() ? '?' + params.toString() : ''}`;

  GET(url, onSuccess, onError);
};